import React, { useEffect } from 'react';
import MasterComponent from '../../components/Forms';
import { ColumnConfig, FormColumnConfig, MasterConfigs } from '../../interfaces/entity';
import { Button, Modal } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { getData } from '../../actions/apiCall';

const EmailTemplateMapping = () => {
    const [htmlCode, setHtmlCode] = React.useState('')
    const [isVisible, setIsVisible] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const dispatch = useDispatch();


    useEffect(() => {
        if (htmlCode) {
            setIsVisible(true)
        }
    }, [htmlCode])


    const getMailTemplate = async (id) => {
        try {
            setLoading(true)
            const resData = await dispatch(getData(`/cms/emailKeysMap/get/mail/template/with/${id}`))
            if (resData.code == 200) {
                setHtmlCode(resData.data.mailTemplate)
            } else {
                console.log(resData)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    const config: MasterConfigs = {
        modalTitle: (action) => `${action} Email Template Mapping`,
        title: 'Email Template Mapping',
        api: () => '/mail-template-mapping',
        isActionTab: true,
        getColumns: () => [
            {
                title: 'Email Template For',
                dataIndex: 'module',
                key: 'module',
            },
            {
                title: 'Mail Key',
                dataIndex: 'mailLinkTo',
                key: 'mailLinkTo',
            },
            {
                title: 'Template Name',
                dataIndex: 'emailTemplate',
                key: 'emailTemplate',
                render: (e) => e.name
            },
            {
                title: 'Mail Template',
                dataIndex: 'emailTemplate',
                key: 'emailTemplate',
                render: (e) => <Button loading={loading} type='link'
                    onClick={() => {
                        getMailTemplate(e._id)
                    }}
                    icon={<EyeOutlined />} />
            }
        ] as ColumnConfig[],
        getFormColumns: () => [
            {
                label: 'Email Template For',
                name: 'module',
                type: 'select',
                isCombo: true,
                rules: [{ required: true, message: 'Please select Email Template For!' }],
            },
            {
                label: 'Mail Key',
                name: 'mailLinkTo',
                type: 'select',
                isCombo: true,
                rules: [{ required: true, message: 'Please select Mail Link To!' }],
            },
            {
                span: 6
            },
            {
                label: 'Template Name',
                name: 'emailTemplate',
                type: 'select',
                isCombo: true,
                rules: [{ required: true, message: 'Please select Template Name!' }],
            }
        ] as FormColumnConfig[],
        combo: [
            {
                name: 'module',
                api: '/cms/emailKeysMap/get/mail/template/module',
                idKey: 'id',
                render: (e) => e.name
            },
            {
                name: 'mailLinkTo',
                api: '/cms/emailKeysMap/get/mail/template/link-key',
                idKey: 'id',
                render: (e) => e.name
            },
            {
                name: 'emailTemplate',
                api: '/cms/emailTemplates',
                idKey: '_id',
                render: (e) => e.name
            }
        ],
        actions: [{ name: 'Add', actionType: 'Add' }]
    }

    return <>
        <Modal
            width={800}
            open={isVisible}
            maskClosable={false}
            title={'Email Template Mapping'}
            okText={false}
            okButtonProps={{ style: { display: 'none' } }}
            onCancel={() => {
                setIsVisible(false)
                setHtmlCode(null)
            }}>
            <div dangerouslySetInnerHTML={{ __html: htmlCode }} style={{ maxWidth: 600, margin: 'auto' }}></div>
        </Modal>
        <MasterComponent config={config} />
    </>
}


export default EmailTemplateMapping